import { BOX_KEYS } from '@dataplace.ai/ui-components/organisms/GenericBoxResult/utils/boxes'
import { ITileData } from 'apps/placeme/src/features/Analyse/slice/@types/ITileData'
import { ReactNode } from 'react'

export type AttractivenessValue = typeof BOX_KEYS[keyof typeof BOX_KEYS]

export interface MapFeature {
  type: 'Feature'
  geometry: {
    coordinates: number[]
    type: string
  }
  properties: {
    title: string | HTMLElement
    segment: AttractivenessValue
  }
}

export interface IAttractivenessResponseValue {
  attractiveness: {
    attractiveness: AttractivenessValue
    percentile?: number
    catchmentId: string
    settings: {
      includeOwnChain: boolean
      businessType: string
      ageBuckets: string[]
      traffic: {
        type: string
        dayparts: string[]
        weekparts: string[]
      }
      transportMeans: string
      market: string
    }
    map: {
      features: MapFeature[]
    }
  }
}

export interface IAttractivenessTileBody {
  coordinates: {
    lat: number
    lng: number
  }
  reportId: string
  includeOwnChain: boolean | null
  businessType: string | null
  ageBuckets: string[]
  traffic: {
    type: string | null
    dayparts: string[]
    weekparts: string[]
  }
}

export interface IAttractivenessTileData extends ITileData {
  value: IAttractivenessResponseValue
}

export const AttractivenessFormFields = {
  includeOwnChain: 'includeOwnChain',
  businessType: 'businessType',
  ageBuckets: 'ageBuckets',
  trafficType: 'trafficType',
  transportMeans: 'transportMeans',
  dayparts: 'dayparts',
  weekparts: 'weekparts',
  market: 'market',
} as const

export type FormFieldValue =
  | string
  | boolean
  | string[]
  | null

export interface AttractivenessFormState {
  includeOwnChain: boolean | null
  businessType: string | null
  ageBuckets: string[]
  trafficType: string | null
  transportMeans: string | null
  dayparts: string[]
  weekparts: string[]
  market: string | null
  [key: string]:
  | boolean
  | string
  | string[]
  | null
  | undefined
}

export interface FormElement {
  formStateElement:
  | string
  | number
  | boolean
  | string[]
  | null
  | undefined
  inputKey: typeof AttractivenessFormFields[keyof typeof AttractivenessFormFields]
  options: {
    value: string | number | boolean
    label?: string
  }[]
  title: string
  width?: string
  multi?: boolean
  componentType?: 'checkbox' | 'dropdown' | 'multi-tiles'
  sectionTitle?: string
  sectionDescription?: string | ReactNode
}

export interface AttractivenessFormDataObject {
  formElementData: FormElement[]
}
